<template>
    <div
        :id="uuid"
        ref="embed"
        class="oembed-wrapper"
    />
</template>

<script>
let uid = 1;
import { loadScriptTag } from '@/helpers/utilities';

export default {
    name: 'VimeoEmbed',
    props: {
        src: { type: String, default: undefined },
        preventSeek: { type: [String, Boolean], default: false, options: [true, false, 'forward'] }
    },
    emits: ['play', 'progress', 'duration'],
    data() {
        return {
            // HACK: Don't set player in local state because it makes Vimeo remount
            // player: null,

            uuid: null,
            playbackRate: 1,
            previousTime: 0,
            previousTimestamp: 0,
            isMounted: false
        };
    },
    watch: {
        src: {
            handler(to) {
                if (to) loadScriptTag('https://player.vimeo.com/api/player.js', this.onPlayerScriptLoad);
            },
            immediate: true
        }
    },
    created() {
        this.uuid = `vimeo-${uid}`;
        uid += 1;
    },
    mounted() {
        this.isMounted = true;
    },
    methods: {
        onPlayerScriptLoad() {
            if (!(window.Vimeo && window.Vimeo.Player)) return this.$timeout(this.onPlayerScriptLoad, 1000);
            if (!this.isMounted || !this.uuid) return this.$timeout(this.onPlayerScriptLoad, 200);
            this.player = new window.Vimeo.Player(this.uuid, {
                url: this.src
            });
            this.player.on('timeupdate', this.checkProgress);
            this.player.on('play', () => {
                this.$emit('play');
                this.previousTimestamp = Date.now();
            });
            this.player.on('playbackratechange', ({ playbackRate }) => this.playbackRate = playbackRate);
            if (this.player.getDuration) this.player.getDuration().then(duration => this.$emit('duration', duration));
        },
        checkProgress({ seconds, percent, duration }) {
            if (this.preventSeek === true || this.preventSeek === 'forward') {
                // HACK: We can't prevent seeking so we have to check for it manually
                const tick = (Date.now() - this.previousTimestamp) / 1000;
                const timeDiff = seconds - this.previousTime;
                if (timeDiff > (tick * this.playbackRate * 1.2)) {
                    return this.player.setCurrentTime(this.previousTime);
                }
            }

            this.previousTime = seconds;
            this.previousTimestamp = Date.now();
            this.$emit('progress', { progress: percent, duration });
        },
        pause() {
            if (!this.player) return;
            this.player.pause();
        }
    }
};
</script>
